import React, { ReactNode } from "react";
import styled from "styled-components";

type Props = {
  children: ReactNode | ReactNode[];
  isBracketOption?: boolean;
};

const Wrapper = styled.div<{ isBracketOption?: boolean }>`
  margin: 0 auto;
  max-width: 100%;

  ${({ isBracketOption }) => {
    if (isBracketOption) return `min-width: auto; width: 500px;`;
    else
      return `
      min-width: 300px;
      height: 100%;
    `;
  }}

  @media (min-width: 1441px) {
    min-width: 100%;
    padding: 0px 34px;
  }
  
  @media (max-width: 1440px) {
    margin: 0 auto;
    ${({ isBracketOption }) => {
      if (isBracketOption) return `padding: 0 10px;`;
      else return `padding: 0 25px;`;
    }}
    }
    
    @media (max-width: 767px) {
      padding: 0px 16px;
    }
`;

export const SectionContent = ({ children, isBracketOption }: Props) => {
  return <Wrapper isBracketOption={isBracketOption}>{children}</Wrapper>;
};
